import React, { useEffect, useState } from "react";
import NavigationBar from "../../components/element/NavigationBar";
import FBOHeaderBar from "../../components/element/FBOHeaderBar";
import { Link } from "react-router-dom";
import useFBOApi from "../../services/api/useFBOApi";
import { useQuery } from "@tanstack/react-query";
import "./CSS/ViewFuelRoyaltySubmittedData.css";
import { PAGINATION_PAGE_SIZE } from "../../utils/constants";
import ROUTE_PATHS from "../../utils/routePaths";
import ViewFuelRoyaltySubmittedTable from "./Tables/ViewFuelRoyaltySubmittedTable";
import { CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import ViewFuelRoyaltySubmittedDataFilter from "./Views/ViewFuelRoyaltySubmittedDataFilter";
import dayjs from "dayjs";

const ViewFuelRoyaltySubmittedData = () => {
  const pageSize = PAGINATION_PAGE_SIZE;
  const [currentPage, setCurrentPage] = useState(() => {
    return sessionStorage.getItem("viewFuelRoyaltyCurrentPage")
      ? Number(sessionStorage.getItem("viewFuelRoyaltyCurrentPage"))
      : 0;
  });
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [meterId, setMeterId] = useState(null);
  const [submissionDate, setSubmissionDate] = useState(null);
  const {
    fetchSubmittedFuelReadingData,
    fetchFilteredSubmittedFuelReadingData,
  } = useFBOApi();

  const {
    data: fuelMeterSubmittedData,
    error,
    isLoading,
  } = useQuery({
    queryKey: isFilterApplied
      ? [
          "filter-fuel-meter-submitted-reading",
          currentPage,
          meterId,
          submissionDate,
        ]
      : ["fuel-meter-submitted-reading", currentPage],
    queryFn: () => {
      if (isFilterApplied) {
        return fetchFilteredSubmittedFuelReadingData({
          meterId: meterId,
          date: submissionDate ?? "",
          page: currentPage,
          size: pageSize,
        });
      } else {
        return fetchSubmittedFuelReadingData({
          page: currentPage,
          size: pageSize,
        });
      }
    },
  });

  useEffect(() => {
    sessionStorage.setItem("viewFuelRoyaltyCurrentPage", currentPage);
  }, [currentPage]);

  const handleNextPage = () => {
    if (currentPage + 1 < fuelMeterSubmittedData?.data?.totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleClearFilter = () => {
    setMeterId(null);
    setSubmissionDate(null);
    setCurrentPage(0);
    setIsFilterApplied(false);
  };

  const handleApplyFilter = (meterIdValue, submissionDateValue) => {
    // Check if at least one filter is selected
    const hasMeterId = meterIdValue && meterIdValue.trim() !== "";
    const hasSubmissionDate = submissionDateValue !== null;
    
    if (!hasMeterId && !hasSubmissionDate) {
      // No filters selected, don't apply filters
      return;
    }
    
    setMeterId(meterIdValue);
    if (submissionDateValue !== null) {
      setSubmissionDate(dayjs(submissionDateValue).format("YYYY-MM-DD"));
    }
    setCurrentPage(0);
    setIsFilterApplied(true);
  };

  return (
    <div>
      <NavigationBar />
      <FBOHeaderBar
        title={"Fuel Royalty"}
        backContent={
          <div className="navigation-header">
            <Link to={ROUTE_PATHS.FBO_HOME} className="navigation-header-link">
              Home/
            </Link>
            <Link
              to={ROUTE_PATHS.FUEL_ROYALTY_HOME}
              className="navigation-header-link"
            >
              Fuel Royalty/
            </Link>
            View Data
          </div>
        }
      />
      <ViewFuelRoyaltySubmittedDataFilter
        onClickClear={handleClearFilter}
        onClickApply={handleApplyFilter}
      ></ViewFuelRoyaltySubmittedDataFilter>
      <ViewFuelRoyaltySubmittedTable
        fuelReading={fuelMeterSubmittedData?.data?.content}
        isLoading={isLoading}
        error={error}
      />
      {fuelMeterSubmittedData?.data?.content &&
        fuelMeterSubmittedData?.data?.content.length > 0 && (
          <div className="pagination-container">
            <div className="pagination-content">
              Page {currentPage + 1} of{" "}
              {fuelMeterSubmittedData?.data?.totalPages}
            </div>
            <button
              className="pagination-button"
              onClick={handlePreviousPage}
              disabled={currentPage === 0}
            >
              <CaretLeftOutlined />
            </button>
            <button
              className="pagination-button"
              onClick={handleNextPage}
              disabled={
                currentPage + 1 === fuelMeterSubmittedData?.data?.totalPages
              }
            >
              <CaretRightOutlined />
            </button>
          </div>
        )}
    </div>
  );
};

export default ViewFuelRoyaltySubmittedData;
